export default __webpack_public_path__ + "static/media/holidays.99af0199.svg";